import { type ComponentType } from "react";

import { LanguageMenu } from "@/components/language-menu";
import { NotificationDropdown } from "@/features/notifications/modules/notification-dropdown/notification-dropdown";

export type NavbarAction = {
  id: string;
  component: ComponentType;
};

const HeaderLanguageMenu = () => <LanguageMenu variant="icon" />;

/** Icons in the navbar action area. */
export const navbarActions: NavbarAction[] = [
  { id: "language", component: HeaderLanguageMenu },
  { id: "notifications", component: NotificationDropdown },
];

/** Items inside the user avatar dropdown. */
export const userMenuActions: NavbarAction[] = [];

/**
 * Blocks a sidebar layout renders above its navigation. Empty here: the starter put an
 * organization switcher in this slot, and people who train with a coach are not members of
 * anything - which coach they are looking at comes from their client record, not from an
 * organization. See features/booking/hooks/use-booking-client.ts.
 */
export const sidebarActions: NavbarAction[] = [];
